// Polyfills
Number.isNaN = Number.isNaN || function (value) {
    return value !== value;
};

// Function to set up inline article ads
export function setupInlineArticleAds() {
    // Find the body copy container
    var bodyCopy = document.querySelector('[data-ads-body-copy]');
    if (!bodyCopy) {
        console.warn('No body copy section found.');
        return;
    }

    // Check if already parsed
    if (bodyCopy.getAttribute('data-ads-parsed')) {
        return;
    }

    // Find the ad sizes element and get size mappings
    var adSizesElem = document.querySelector('[data-article-ad-sizes]');
    if (!adSizesElem) {
        console.warn('No ad sizes found.');
        return;
    }

    var sizeMappings = $(adSizesElem).data('article-ad-sizes');
    if (!sizeMappings) {
        try {
            sizeMappings = JSON.parse(adSizesElem.getAttribute('data-article-ad-sizes'));
        } catch (e) {
            console.warn('Invalid size mapping JSON in data-article-ad-sizes.');
            return;
        }
    }

    // Setup Handlebars template
    if (typeof Handlebars === 'undefined') {
        console.error('Handlebars not loaded.');
        return;
    }
    if (!Handlebars.helpers.json) {
        Handlebars.registerHelper('json', function (context) {
            return JSON.stringify(context);
        });
    }
    var adSlotTemplate = Handlebars.compile($('#ad-slot-template').html());

    var isDesktop = !!(window.isViewportGreaterThanOrEqualTo && window.isViewportGreaterThanOrEqualTo('md'));
    var wordsPerAd = isDesktop ? 300 : 200;

    var allParagraphs = Array.from(bodyCopy.querySelectorAll('p'));
    var paragraphs = allParagraphs.filter(function (p) {
        return !p.closest('table');
    });

    var words = 0;
    var adSlotNumber = 2;
    var adsAdded = 0;

    for (var i = 0; i < paragraphs.length; i++) {
        var paragraph = paragraphs[i];
        var paragraphWords = paragraph.textContent.trim().split(/\s+/).length;

        if (paragraphWords + words > wordsPerAd) {
            var slotId = 'inline-' + (adSlotNumber < 10 ? '0' + adSlotNumber : adSlotNumber);
            if (!document.getElementById(slotId)) {
                var adSlotData = {
                    slotId: slotId,
                    sizeMapping: sizeMappings,
                    paddingClass: 'pb-3'
                };
                var adSlotHtml = adSlotTemplate(adSlotData);
                $(paragraph).after(adSlotHtml);

                words = 0;
                adSlotNumber++;
                adsAdded++;
            }
        } else {
            words += paragraphWords;
        }
    }

    if (adsAdded === 0) {
        var slotId = 'inline-' + (adSlotNumber < 10 ? '0' + adSlotNumber : adSlotNumber);
        if (!document.getElementById(slotId)) {
            var adSlotData = {
                slotId: slotId,
                sizeMapping: sizeMappings,
                paddingClass: 'pb-3'
            };
            var adSlotHtml = adSlotTemplate(adSlotData);
            $(bodyCopy).append(adSlotHtml);
        }
    }

    bodyCopy.setAttribute('data-ads-parsed', 'true');
    console.log('Inline article ads inserted.');
}

// Function to set up Assertive Yield
export function setupAssertiveYield() {
    window.ayManagerEnv = window.ayManagerEnv || { cmd: [] };

    if (typeof Handlebars === 'undefined') {
        console.error('Handlebars not loaded.');
    }
    if (!Handlebars.helpers.json) {
        Handlebars.registerHelper('json', function (context) {
            return JSON.stringify(context);
        });
    }
    const adSlotTemplate = Handlebars.compile(
        document.getElementById('ad-slot-template').innerHTML
    );

    const adSlots = {};
    const adSections = document.querySelectorAll('[data-ad-id]');
    if (adSections.length === 0) {
        console.warn('No ad section found.');
    }

    adSections.forEach(function (section) {
        const adDataInputs = section.querySelectorAll('[data-ad-data]');
        adDataInputs.forEach(function (adSlot) {
            let adSlotData = adSlot.getAttribute('data-ad-data');
            try {
                adSlotData = JSON.parse(adSlotData);
            } catch (e) {
                console.warn('Invalid JSON in data-ad-data:', adSlotData);
            }
            if (!adSlotData || !adSlotData.slotId) {
                console.warn('Invalid ad slot data:', adSlotData);
            }
            const adSlotHtml = adSlotTemplate(adSlotData);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = adSlotHtml;
            const newSlotElem = tempDiv.firstElementChild;

            adSlot.parentNode.replaceChild(newSlotElem, adSlot);

            adSlots[adSlotData.slotId] = {
                slotId: adSlotData.slotId,
                sizeMapping: adSlotData.sizeMapping,
                isEager: adSlotData.isEager || false,
                outOfPage: adSlotData.outOfPage || false,
                container: document.getElementById(adSlotData.slotId + '-container'),
                element: document.getElementById(adSlotData.slotId)
            };
        });

        setupAdMovement(adSlots, section);
    });

    function shouldAdd(adSlot) {
        return !!adSlot.container.closest('[data-ads-hidden-column]');
    }

    function getIndex(adSlot) {
        const hiddenColumn = adSlot.container.closest('[data-ads-hidden-column]');
        if (!hiddenColumn) return -1;
        const holders = Array.from(hiddenColumn.querySelectorAll('[data-ad-slot-name]')).map(e => e.parentNode);
        const holder = adSlot.container.parentNode;
        return holders.indexOf(holder);
    }

    function setupAdMovement(adSlots, adSection) {
        const slotsToAdd = [];
        for (let name in adSlots) {
            if (adSlots.hasOwnProperty(name)) {
                const slot = adSlots[name];
                if (shouldAdd(slot)) {
                    slotsToAdd.push(slot);
                }
            }
        }
        if (slotsToAdd.length === 0) return;
        slotsToAdd.sort((a, b) => getIndex(a) - getIndex(b));
        for (let adSlot of slotsToAdd) {
            const slotName = adSlot.slotId;
            const desktopSlot = adSlot.container;
            let mobileReplacementSlot = adSection.querySelector(`[data-ad-mobile-replace="${slotName}"]`);
            if (!mobileReplacementSlot) {
                mobileReplacementSlot = document.createElement('div');
                mobileReplacementSlot.setAttribute('data-ad-mobile-replace', slotName);
                mobileReplacementSlot.className = 'col-md-6 mb-3 text-center';
                adSection.appendChild(mobileReplacementSlot);
            }
            const responsiveMovable = desktopSlot.getAttribute('data-responsive-movable');
            mobileReplacementSlot.setAttribute('data-responsive-movable-xs', responsiveMovable);
            mobileReplacementSlot.setAttribute('data-responsive-movable-sm', responsiveMovable);
        }
    }

    if (window.registerMovableElements && window.moveElementsToCurrentViewport) {
        window.registerMovableElements(window.jQuery || $);
        window.moveElementsToCurrentViewport(true);
    }

    window.ayManagerEnv.cmd.push(function () {
        ayManagerEnv.changePage();
    });
        
}

// Consent data processing function
function consentData(tcData) {
    console.time('consentData');

    if (tcData.gdprApplies === true) {
        console.log("GDPR applies. Processing consent data...");

        __tcfapi('getCustomVendorConsents', 2, function (vendorConsents, success) {
            console.log(vendorConsents);

            if (vendorConsents) {
                const bauerMedia = vendorConsents.grants?.["5f8036e6145f6b2baf93e3d6"]?.vendorGrant;

                if (!tcData.purpose?.consents) {
                    console.warn('Purpose or Purpose Consents is undefined in tcData');
                    window.permutive.consent({ "opt_in": false });
                } else {
                    if (!tcData.purpose.consents[1] || !tcData.purpose.consents[3] || !tcData.purpose.consents[4] || !bauerMedia) {
                        window.permutive.consent({ "opt_in": false });
                    } else {
                        window.permutive.consent({ "opt_in": true, "token": "CONSENT_CAPTURED" });
                    }
                }
            } else {
                console.warn('Vendor Consents is undefined or null');
                window.permutive.consent({ "opt_in": false });
            }
        });
    } else {
        console.log("GDPR does not apply. Defaulting to opt-in behavior.");
        window.permutive.consent({ "opt_in": true });
    }

    console.timeEnd('consentData');
}

// Add event listener for TCF API
__tcfapi('addEventListener', 2, function (tcData, success) {
    console.timeEnd('CMP');
    if (success && tcData.eventStatus === 'cmpuishown') {
        console.log('SP: Surfacing CMP interface.');
    }

    if (success && tcData.eventStatus === 'useractioncomplete') {
        console.log('SP: User submitted consent choices.');
        consentData(tcData);
    }

    if (success && tcData.eventStatus === 'tcloaded') {
        console.log('SP: TC string available.');

        window.__tcfapi('removeEventListener', 2, function (success) {
            if (success) {
                console.log('SP: Event listener removed.');
            }
        }, tcData.listenerId);

        consentData(tcData);
    }
});

$(window).on('load', function () {
    var checkAd = setTimeout(function () {
        if ($('#inline-01-container').height() === 0) {
            console.log('Ad-blocker detected!');
            $("*").removeClass("sticky-dfp-ad");
        }
    }, 2000); // wait 2 seconds after the 'load' event
});